import { setOrderRefreshCallback } from '../services/WebsocketNotificationService';

// Callback для перезагрузки заказов
type OrderRefreshCallback = () => void;
const orderRefreshCallbacks: Set<OrderRefreshCallback> = new Set();

/**
 * Регистрирует callback для обновления заказов
 * Возвращает функцию для отписки
 */
export function registerOrderRefreshCallback(callback: OrderRefreshCallback): () => void {
  orderRefreshCallbacks.add(callback);
  return () => orderRefreshCallbacks.delete(callback);
}

/**
 * Вызывает все зарегистрированные callback'и для обновления заказов
 */
export function triggerOrderRefresh(): void {
  orderRefreshCallbacks.forEach(callback => callback());
}

// Wire WebSocket globalOrderRefreshCallback to triggerOrderRefresh
// This ensures WebSocket messages trigger UI refresh of all registered components
setOrderRefreshCallback(() => {
  orderRefreshCallbacks.forEach(callback => callback());
});

export default { registerOrderRefreshCallback, triggerOrderRefresh };
